import React from 'react';
import CouponForm from './form';
import {addCouponItem} from '../../modules/Api';
import {normalizer} from './pipeline';
import {notification} from 'antd';

class AddCoupon extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = normalizer(values);
        addCouponItem(formData, () => {
            notification.open({
                message: `کوپن با موفقیت اضافه شد!`,
                description: `کوپن ثبت شد. می توانید آن را در لیست کوپن ها مشاهده کنید و در صورت نیاز ویرایش کنید.`
            });
            this.setState({submitted: false});
        });
    }
    render() {
        return (<div><CouponForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default AddCoupon;


// WEBPACK FOOTER //
// ./src/containers/Users/add.js